// Auto-generated normalizer for table: Empleados_AreaNegocio
export function empleadosAreaNegocioNormalize(row) {
  return {
    idEmpleadoArea: row.idEmpleadoArea ?? row.IdEmpleadoArea ?? row['IdEmpleadoArea'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    idAreaNegocio: row.idAreaNegocio ?? row.IdAreaNegocio ?? row['IdAreaNegocio'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? row['FechaAsignacion'] ?? null,
  };
}
